/**
 * FUEL GAUGE
 */

const calHeightGauge = () => {
  let heightToDecrease = [
    getEl("nav"),
    getEl("#instruction"),
    getEl("#bouton_valider"),
  ]
    .filter((x) => x.getClientRects().length > 0)
    .map((x) => x.getClientRects()[0].height + 7);

  let containerHeight = getEl(".ctn").clientHeight;
  let totalHeight = containerHeight - heightToDecrease.reduce((a, b) => a + b);

  getEl("#divsvg").style.height = `${totalHeight}px`;
};

const resetFuel = () => {
  cursor.setAttributeNS(null, "y", maxy);
  fuel.setAttributeNS(null, "y", maxy);
  gauge.lastChild.data = "0";
};

const getFuelLevel = () => {
  return (
    (basJauge - parseFloat(fuel.getAttributeNS(null, "y"))) /
    (basJauge - hautJauge)
  );
};

const getMousePosition = (evt) => {
  let CTM = svg.getScreenCTM();
  if (evt.touches && evt.touches.length > 0) {
    evt = evt.touches[0];
  }
  return {
    x: (evt.clientX - CTM.e) / CTM.a,
    y: (evt.clientY - CTM.f) / CTM.d,
  };
};

const startDrag = (evt) => {
  dragging = true;
  only_click = true;
  lastCoord = getMousePosition(evt);
  offset = getMousePosition(evt); //uncomment if you want to use the offset
  //offset.x -= parseFloat(fuel.getAttributeNS(null, "x"));
  offset.y -= parseFloat(fuel.getAttributeNS(null, "y"));
  if (validationButton.disabled) {
    validationButton.disabled = false;
  }
};

const drag = (evt) => {
  if (dragging == true) {
    only_click = false;
    if (isMobile != true) {
      evt.preventDefault();
    }
    const coord = getMousePosition(evt);
    const hauteurJauge = Math.max(miny, Math.min(maxy, coord.y - offset.y));
    const textJauge = closestGraduation(hauteurJauge).label;
    gauge.lastChild.data = textJauge;
    hauteurJauge < maxy && hide(helpMessage);
    fuel.setAttributeNS(null, "y", hauteurJauge);
    cursor.setAttributeNS(null, "y", hauteurJauge);
    lastHauteurJauge = hauteurJauge;
  }
};

const endDrag = (evt) => {
  if (
    evt.target.id &&
    only_click &&
    (evt.target == svg ||
      evt.target.id.indexOf("Ligne") > -1 ||
      evt.target.id.indexOf("Carburant") > -1)
  ) {
    // Il n'y a pas eu de drag, déplacer la jauge jusqu'au click
    let coord;
    if (isMobile != true) {
      evt.preventDefault();
      coord = lastCoord;
    } else {
      coord = getMousePosition(evt);
    }
    const hauteurJauge = Math.max(miny, Math.min(maxy, coord.y));
    const textJauge = closestGraduation(hauteurJauge).label;
    gauge.lastChild.data = textJauge;
    //fuel.setAttributeNS(null, "x", coord.x - offset.x);
    if (hauteurJauge < maxy) {
      hide(helpMessage);
    }

    if (hauteurJauge > 0) {
      fuel.setAttributeNS(null, "y", hauteurJauge);
      cursor.setAttributeNS(null, "y", hauteurJauge);
      lastHauteurJauge = hauteurJauge;
      click = false;
    }
  }

  const ajustement = closestGraduation(
    parseFloat(fuel.getAttributeNS(null, "y"))
  ).value;
  const closest = basJauge - ajustement * (basJauge - hautJauge);
  fuel.setAttributeNS(null, "y", Math.max(miny, Math.min(maxy, closest)));
  cursor.setAttributeNS(null, "y", Math.max(miny, Math.min(maxy, closest)));
  dragging = false;

  if (lastHauteurJauge >= maxy) {
    hide(helpMessage);
  }

  if (state.stepName === "carburantActuel") {
    state.niveauCarbAct = getFuelLevel();
  } else if (state.stepName === "carburantSouhaite") {
    state.niveauCarbSouhaite = getFuelLevel();
  }
};

svg.addEventListener("mousedown", startDrag);
// svg.addEventListener('mouseleave', endDrag);
document.addEventListener("mousemove", drag);
document.addEventListener("mouseup", endDrag);

svg.addEventListener("touchstart", startDrag);
document.addEventListener("touchmove", drag);
document.addEventListener("touchend", endDrag);
document.addEventListener("touchleave", endDrag);
document.addEventListener("touchcancel", endDrag);

const fuelLevel = [
  { label: 0, value: 0 },
  { label: "1/16", value: 1 / 16 },
  { label: "1/8", value: 1 / 8 },
  { label: "3/16", value: 3 / 16 },
  { label: "1/4", value: 1 / 4 },
  { label: "5/16", value: 5 / 16 },
  { label: "3/8", value: 3 / 8 },
  { label: "7/16", value: 7 / 16 },
  { label: "1/2", value: 1 / 2 },
  { label: "9/16", value: 9 / 16 },
  { label: "5/8", value: 5 / 8 },
  { label: "11/16", value: 11 / 16 },
  { label: "3/4", value: 3 / 4 },
  { label: "13/16", value: 13 / 16 },
  { label: "7/8", value: 7 / 8 },
  { label: "15/16", value: 15 / 16 },
  { label: "Plein", value: 1 },
];

function closestGraduation(niveau) {
  const niveau_ajuste = (basJauge - niveau) / (basJauge - hautJauge);
  for (var i = 1; i < fuelLevel.length; i++) {
    if (fuelLevel[i].value > niveau_ajuste) {
      if (
        fuelLevel[i].value - niveau_ajuste <
        niveau_ajuste - fuelLevel[i - 1].value
      ) {
        return fuelLevel[i];
      } else {
        return fuelLevel[i - 1];
      }
    }
  }
  return fuelLevel[fuelLevel.length - 1];
}
